/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import {
  BillIcon,
  CardPaymentV2Icon,
  EndOfDayIcon,
  PendingIcon,
  SalesIconV2,
} from "../../../../assets/svgIcons";
import styles from "./styles.module.scss";
import secondaryComponents from "../..";
import { useGetInfo } from "../../../../hooks/useGetInfo";
import { useNavigate, useParams } from "react-router-dom";
import { MenuMoreIcon } from "../../../../assets/svgIcons/SellModeIconsV2/MenuMoreIcon";
import { MenuHeader } from "../MobileMenu/MenuHeader";
import { MoreMenuNav } from "../MoreMenuNav";
import { pathConstants } from "../../../../routes/pathContants";
import { RecievePaymentPrompt } from "../PaymentPrompt/RecievePaymentPrompt";
import { RoutedModal } from "../../../common";
import {
  useGetOrderList,
  useGetPendingSessions,
} from "../../../../hooks/api/queries/useOrder";
import { truncateString } from "../../../../helpers";

export const SellModeSideNav = () => {
  const [isMore, setIsMore] = useState(false);
  const { store_id } = useParams();
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const navigate = useNavigate();
  const [views, setViews] = useState({
    isPayment: false,
  });
  const { data: pendingSession } = useGetPendingSessions({
    queries: `?store_id=${store_id}`,
    isEnabled: true,
  });
  const { data: bills } = useGetOrderList({
    queries: `?store_id=${store_id}&payment_method=bill`,
    isEnabled: true,
  });
  const pendingMetaDetails = pendingSession?.meta;
  const billsMetaDetails = bills?.meta;

  return (
    <>
      <section className={`${styles.sellModeSideNav}`}>
        <div className={styles.navigation}>
          {storeDetails?.support_raven_payment && (
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
            >
              <a
                className={styles.navigation__item}
                onClick={() =>
                  setViews((prev) => ({ ...prev, isPayment: true }))
                }
              >
                <CardPaymentV2Icon />
                <span>Recieve Payments</span>
              </a>
            </secondaryComponents.NavigateWithPermission>
          )}

          {storeDetails?.allow_generate_bill && (
            <a
              className={styles.navigation__item}
              onClick={() =>
                navigate(
                  pathConstants.SELL_MODE_BILLS({
                    store_id,
                  }) + `?store_id=${store_id}&payment_method=bill`,
                )
              }
            >
              <BillIcon />
              <span>Bills</span>
              {billsMetaDetails?.total > 0 ? (
                <span className={styles.noOfPends}>
                  {truncateString(billsMetaDetails?.total, 3)}
                </span>
              ) : null}
            </a>
          )}
          <a
            className={styles.navigation__item}
            onClick={() =>
              navigate(
                pathConstants.SELL_MODE_PENDING_CHECKOUT({
                  store_id,
                }) + `?store_id=${store_id}&status=PENDING_CHECKOUT`,
              )
            }
          >
            <PendingIcon />
            <span>Pending</span>
            {pendingMetaDetails?.total > 0 ? (
              <span className={styles.noOfPends}>
                {pendingMetaDetails?.total}
              </span>
            ) : null}
          </a>

          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_generate_end_of_day"
            showOnLocalSetup={true}
          >
            <a
              className={styles.navigation__item}
              onClick={() =>
                navigate(
                  pathConstants.SELL_MODE_ENDOFDAY({
                    store_id,
                  }) + `?store_id=${store_id}`,
                )
              }
            >
              <EndOfDayIcon />
              <span>End Of Day</span>
            </a>
          </secondaryComponents.NavigateWithPermission>
          <a
            className={styles.navigation__item}
            onClick={() =>
              navigate(
                pathConstants.SELL_MODE_SALES({
                  store_id,
                }) + `?store_id=${store_id}`,
              )
            }
          >
            <SalesIconV2 />
            <span>Sales</span>
          </a>

          <a
            className={styles.navigation__item}
            onClick={() => setIsMore(true)}
          >
            <MenuMoreIcon />
            <span>More</span>
          </a>
        </div>
      </section>

      <secondaryComponents.Modal
        isActive={isMore}
        width={500}
        closeModal={() => setIsMore(false)}
        style={{ padding: 0, left: "100px", bottom: "20px" }}
        backDropStyle={{ justifyContent: "flex-start", alignItems: "flex-end" }}
      >
        <MenuHeader title="More" closeModal={() => setIsMore(false)} />
        <MoreMenuNav isMoreMenu={true} closeModal={() => setIsMore(false)} />
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={views?.isPayment}
        width={600}
        style={{ height: "auto" }}
        headerTitle="Collect Payments"
        headerDescription="Receive payment via transfer or card"
        closeModal={() => setViews((prev) => ({ ...prev, isPayment: false }))}
      >
        <RecievePaymentPrompt />
      </RoutedModal>
    </>
  );
};
